import 'bootstrap-datepicker'
import '../../../node_modules/bootstrap-datepicker/dist/locales/bootstrap-datepicker.ja.min.js'

const [ d ] = [ document ]


const init = () => {
  // ajaxzipの適用
  Array.prototype.forEach.call( d.querySelectorAll('[data-plugin="ajaxzip"]'), apply_ajaxzip )

  // flatpickerの適用
  apply_datepicker( d.querySelector('[data-plugin="datepicker"],[name="配送希望日"],[name="お日にち"]') )
}

const apply_ajaxzip = obj => {
  if( !obj || obj.length == 0 ) return
  const target = obj.dataset.target.split(',')
  switch ( obj.tagName.toLowerCase() ) {
    case 'button':
      obj.type = "button"
      obj.addEventListener( 'click', () => {
        AjaxZip3.zip2addr( `${target[0]}`, '', `${target[1]}`, `${target[2]}` ); // eslint-disable-line no-undef
        return false
      })
      break
    case 'input':
      obj.addEventListener( 'keyup', () => {
        AjaxZip3.zip2addr( `${target[0]}`, '', `${target[1]}`, `${target[2]}` ); // eslint-disable-line no-undef
        return false
      })
      break
  }
}

const apply_datepicker = obj => {
  if( !obj || obj.length == 0 ) return
  const endDate = new Date();
  const startDate = new Date();
  const defaultViewDate = new Date();
  switch( obj.name ){
    case 'お日にち':
      startDate.setDate( startDate.getDate() + 1 )
      endDate.setDate( endDate.getDate() + 60 )
      break;
    case '配送希望日':
      endDate.setDate( endDate.getDate() + 28 )
      startDate.setDate( startDate.getDate() + 5 )
      break;
    case '購入日':
    default :
      startDate.setFullYear( 1968 )
      break;
  }
  $(obj).datepicker({
    endDate,
    startDate,
    defaultViewDate,
    startView: "month",
    language: "ja",
    format: 'yyyy年mm月dd日',
    autoclose: true
  })
}

export default function FORM (){
  d.addEventListener( 'DOMContentLoaded', init )
}